import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AutoBindComponent from "../common/AutoBindComponent";

import Fieldset from "../common/Fieldset";
import Form from "../common/Form";
import Row from "../common/Row";
import Section from "../common/Section";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../actions/layoutActions";
import * as types from "../../constants/ComponentConstants";
import classnames from "classnames";

class IndienenBevestigingPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
		};
	}

	componentWillMount() {
		const ingediend = this.props.indienen;
		this.props.loadLayout(ingediend.dossierId, ingediend.dossierNaam, ingediend.tabTitle);
	}

	render() {
		return (
			<Section title="Dien in" color={types.COLOR_GREEN}>
				<Form title="Bevestigingsformulier" name="Bevestigingsformulier" isNotRequired>
					<Fieldset>
						<Row>
							<p>
								Het dossier is ingediend.
								<br/>
								Je kunt geen wijzigingen meer aanbrengen.
							</p>
							<br />
						</Row>
						<Row>
							<div style={{ color: 'orange' }}>
								<div className="o-col-1" style={{ textAlign: 'center' }}>
									<i className={"fa " + classnames(types.FONT_ICON_EXCLAMATION)} style={{ fontSize: '2em' }} />{'   '}
								</div>
								<div className="o-col-11">
									<span style={{ fontSize: '.875rem' }}>
										Er werd een bevestigingsmail verstuurd naar de contactpersonen van het subsidiedossier.
										<br/>
										Heb je nog vragen? Contacteer Sport Vlaanderen via <a className="minimal" href="mailto:infrastructuur@sport.vlaanderen">infrastructuur@sport.vlaanderen</a>.
									</span>
								</div>
							</div>
						</Row>
					</Fieldset>
				</Form>
			</Section >
		);
	}
}

// ----------------------------------------------------------------------------

IndienenBevestigingPage.propTypes = {
	loadLayout: PropTypes.func
};


function mapStateToProps(state, ownProps) {
	return {
		indienen: state.indienen
	};
}
function mapDispatchToProps(dispatch) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadIndienenBevestigingPageLayout, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(IndienenBevestigingPage);
